import { useState } from "react";
import axios from "axios";
import { Tags } from "lucide-react";
import { toast } from "sonner";
import { API, errText, num } from "@/components/bulk/common";

export function GroupBar({ selected, groups, total, onSelectAll, onClear, onDone }) {
  const [name, setName] = useState("VIP Müşteriler");
  const apply = async (action) => {
    if (!name.trim()) { toast.error("Grup adı yazın"); return; }
    if (name.includes("/")) { toast.error("Grup adında / işareti kullanılamaz"); return; }
    try {
      const r = await axios.post(`${API}/bulk/contacts/groups`, { group: name, phones: [...selected], action });
      toast.success(action === "add" ? `${num(selected.size)} kişi "${r.data.group}" grubuna eklendi` : `${num(selected.size)} kişi "${r.data.group}" grubundan çıkarıldı`);
      onDone();
    } catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="group-bar" data-testid="group-bar">
      <b data-testid="contacts-selected-count">{num(selected.size)} kişi seçildi</b>
      <button type="button" className="text-btn" onClick={onSelectAll} data-testid="contacts-select-all">Eşleşen tümünü seç ({num(total)})</button>
      <button type="button" className="text-btn" onClick={onClear} data-testid="contacts-clear-selection">Temizle</button>
      <span className="group-bar-right">
        <input list="group-names" maxLength={40} value={name} onChange={(e) => setName(e.target.value)} placeholder="Grup adı" data-testid="group-name-input" />
        <datalist id="group-names">{[...new Set(["VIP Müşteriler", ...groups.map((g) => g.name)])].map((g) => <option key={g} value={g} />)}</datalist>
        <button type="button" className="primary-btn" onClick={() => apply("add")} data-testid="group-add-button"><Tags size={14} />Gruba ekle</button>
        <button type="button" className="outline-btn" onClick={() => apply("remove")} data-testid="group-remove-button">Gruptan çıkar</button>
      </span>
    </div>
  );
}
